<template>
  <div class="navbar-wrapper">
    <b-navbar toggleable="lg" type="dark" variant="dark" fixed="top" class="modern-navbar">
      <b-container>
        <router-link to="/" class="brand navbar-brand">
          <div class="brand-text-container">
            <span class="brand-text">Jens Trompler</span>
            <span class="brand-subtitle">IT Consulting</span>
          </div>
        </router-link>
        <b-navbar-toggle target="nav-collapse" class="ml-auto"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav class="ml-auto">
          <b-navbar-nav class="ml-auto">
            <b-nav-item to="/#ki">KI-Lösungen</b-nav-item>
            <b-nav-item to="/#devops">DevOps</b-nav-item>
            <b-nav-item to="/#technology">Technologien</b-nav-item>
            <b-nav-item to="/impressum">Impressum</b-nav-item>
          </b-navbar-nav>
          <div class="nav-cta d-none d-lg-block">
            <router-link to="/#kontakt" class="contact-button">Kontakt</router-link>
          </div>
        </b-collapse>
      </b-container>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'AppNavbar',
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";

.navbar-wrapper {
  position: absolute;
  width: 100%;
  z-index: 1000;
}

.modern-navbar {
  background: rgba($primary-color, 0.85) !important;
  backdrop-filter: blur(10px);
  padding: 1rem 0;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba($accent-color, 0.2);
  
  &.scrolled {
    padding: 0.5rem 0;
    background: rgba($primary-color, 0.95) !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  }
}

.brand {
  display: flex;
  align-items: center;
  line-height: 1.2;
  
  .logo-container {
    margin-right: 10px;
    
    .logo-svg {
      transition: transform 0.3s ease;
    }
    
    &:hover .logo-svg {
      transform: rotate(10deg);
    }
  }
  
  .brand-text-container {
    display: flex;
    flex-direction: column;
  }
  
  .brand-text {
    font-size: 1.4rem;
    font-weight: 700;
    background: $accent-gradient;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  
  .brand-subtitle {
    font-size: 0.8rem;
    color: $muted-text-color;
    letter-spacing: 1px;
  }
}

.navbar-dark .navbar-nav .nav-link {
  color: $text-color;
  font-weight: 600;
  margin: 0 0.5rem;
  padding: 0.5rem;
  position: relative;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 2px;
    background: $accent-gradient;
    transition: width 0.3s ease;
  }
  
  &:hover, &.active, &.router-link-active, &.router-link-exact-active {
    color: $accent-color;
    
    &::after {
      width: 80%;
    }
  }
}

.nav-cta {
  margin-left: 1.5rem;
}

.contact-button {
  background: transparent;
  border: 2px solid $accent-color;
  color: $accent-color;
  padding: 0.6rem 1.5rem;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.85rem;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  
  &:hover {
    background: $accent-color;
    color: white;
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba($accent-color, 0.4);
  }
}
</style>
